import { useEffect, useState } from "react";

interface ThemeImageProps {
  darkSrc: string;
  lightSrc: string;
  alt: string;
  className?: string;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
  width?: number;
  height?: number;
}

const ThemeImage = ({ 
  darkSrc, 
  lightSrc, 
  alt, 
  className = "",
  loading = "lazy",
  fetchPriority,
  width,
  height
}: ThemeImageProps) => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const checkTheme = () => {
      setIsDark(document.documentElement.classList.contains("dark"));
    };

    checkTheme();

    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <img
      src={isDark ? darkSrc : lightSrc}
      alt={alt}
      className={className}
      loading={loading}
      fetchPriority={fetchPriority}
      width={width}
      height={height}
    />
  );
};

export default ThemeImage;
